import img1 from "../../assets/Images/Accounting/Ledger of Account.png"

export default function LedgerByAccount() {
    return (
        <section id="ledger-by-account" className="space-y-16">

            {/* HEADER / OVERVIEW (STANDARD ACCOUNTING PATTERN) */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    4. Ledger by Account
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    The Ledger by Account module provides a detailed transaction history
                    for any individual account in the chart of accounts.
                </p>

                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        An account ledger shows all debit and credit movements of a specific
                        account over a selected time period. This helps track balances,
                        verify transactions, and perform financial analysis.
                    </p>
                </section>
            </section>

            {/* ACCOUNT SELECTION */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Selecting an Account
                    </h3>

                    <p className="text-slate-600 mb-4">
                        To view a ledger, the user must first select an account from the
                        Chart of Accounts.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Cash</li>
                        <li>Bank accounts</li>
                        <li>Expense accounts</li>
                        <li>Liability accounts</li>
                        <li>Supplier or payable accounts</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* DATE FILTER */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Date Range Filter
                </h3>

                <p className="text-slate-600 mb-4">
                    Users can filter the ledger by selecting a start and end date.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Start Date (From)</li>
                    <li>End Date (To)</li>
                    <li>Filter applies only to the selected account</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Clicking the <strong>Show</strong> button loads the ledger entries
                    matching the selected criteria.
                </p>
            </section>

            {/* LEDGER VIEW */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Ledger Entries View
                </h3>

                <p className="text-slate-600 mb-4">
                    Once loaded, the ledger displays a complete list of transactions
                    affecting the selected account.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Transaction date</li>
                    <li>Description or narration</li>
                    <li>Debit amount</li>
                    <li>Credit amount</li>
                    <li>Running balance</li>
                    <li>Reference (Expense, Receipt, Purchase, Journal Entry)</li>
                </ul>
            </section>

            {/* BALANCE LOGIC */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Running Balance Calculation
                </h3>

                <p className="text-slate-600 mb-4">
                    EventFlow automatically calculates the running balance for each ledger
                    entry.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Debit increases asset & expense accounts</li>
                    <li>Credit increases liability, equity & income accounts</li>
                    <li>Balance updates after every transaction</li>
                </ul>
            </section>

            {/* ACCOUNTING USE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Practical Uses of Account Ledger
                </h3>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Verify account balances</li>
                    <li>Trace individual transactions</li>
                    <li>Audit financial activity</li>
                    <li>Resolve discrepancies</li>
                    <li>Support trial balance & reports</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Ledger by Account Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    The Ledger by Account is the most detailed financial report in the
                    accounting system. It ensures transparency, accountability, and
                    complete visibility into every account’s financial activity.
                </p>
            </section>

        </section>
    );
}
